import WebGalleryStickyUpsellBanner from './WebGalleryStickyUpsellBanner';

export default WebGalleryStickyUpsellBanner;
